import { ApiRequestConfig } from 'api';
import { get } from 'features/api';
import { TrustDocumentsParams, TrustDocumentsResponse } from '../types';

export const fetchTrustDocuments = (params: TrustDocumentsParams, options: ApiRequestConfig) =>
  get<TrustDocumentsResponse>('trust-documents', params, options);
